import React from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const MultiSelect = ({name, label, options, desc, limit, required, error, control}) => {
  const resultValues = (values) => {
    return limit ? values.slice(0, limit) : values
  }

  return <label className='registration-label'>
    {label}
    {desc && <span className='label-desc'>{desc}</span>}
    <Controller
      control={control}
      name={name}
      rules={{ required: (required ? 'Is required' : false) }}
      render={({ field }) => (
        <Select
          multi
          value={field.value}
          options={options}
          onChange={values => field.onChange(resultValues(values))}
        />
      )}
    />
    {error && <div className='error_container'>{error.message}</div>}
  </label>
}

export default MultiSelect
